import {comp, Component, Config, router} from "@intermesh/goui";
import {ScormApi} from "./util/ScormApi.js";
import {CurrentSection} from "./services/CurrentSection.js";
import {ServerApi} from "./util/ServerApi.js";

declare global {
	var API: ScormApi;
	var finishScorm: any;
	var setSection: any
}

export class ScormCourseSelect extends Component {

	constructor() {
		super("section");
		this.itemId = "section-select-scorm";
		this.id = "section-select-scorm";
		this.cls = "vbox";

		const scormUrl = ServerApi.url("/elearning/selectSectionScorm/", {}, true);

		const me = this;
		window.API = new ScormApi();
		window.API.LMSSetValue("sectionCode","profile");

		window.API.LMSFinish = function(_param: any) {
			me.selectSection(this.data.sectionCode);
			return "true";
		};

		window.setSection = function(code: string){
			window.API.LMSSetValue("sectionCode",code);
		};

		let iframeParams = {
			id: 'scormFrame',
			tagName: 'iframe',
			attr: {
				src: scormUrl,
			},
			cls: "scorm-frame full-screen"
		} as Config<any>;
		this.items.replace(comp(iframeParams));
	}

	private async selectSection(sectionCode: string) {
		if(sectionCode === "profile") {
			void router.goto(sectionCode);
			return;
		}
		CurrentSection.loadByLocationCode(sectionCode).then((_response) => {
			void router.goto("course-selection");
		});
	}
}